import { useEffect, useState } from 'react';

/**
 * Stato di una media query, reattivo a resize e rotazione.
 *
 * Serve nei pochi casi in cui il comportamento responsive non è
 * esprimibile con le classi Tailwind perché dipende da un attributo del
 * DOM e non dallo stile — per esempio l'attributo `open` di `<details>`,
 * che il CSS non può impostare.
 *
 * Per tutto il resto vanno usati i prefissi di breakpoint: questo hook
 * costa un render in più e va usato con parsimonia.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Il breakpoint `lg` di Tailwind, dove il layout passa a desktop. */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');
